import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { ENVIRONMENT, Environment } from '@environment';

@Injectable({
  providedIn: 'root'
})
export class UsheruApi {
  private readonly standardHeader: HttpHeaders;
  private readonly standardPostHeader: HttpHeaders;
  private bearerTokenHeader: HttpHeaders;

  constructor(@Inject(ENVIRONMENT) private env: Environment) {
    this.standardHeader = new HttpHeaders({
      Authorization: this.basicCredentials(),
      'USH-Channel': this.env.api.ushChannel
    });

    this.standardPostHeader = new HttpHeaders({
      Authorization: this.basicCredentials(),
      'USH-Channel': this.env.api.ushChannel,
      'Content-Type': 'application/json'
    });
  }

  private basicCredentials() {
    return 'Basic ' + btoa(this.env.api.user + ':' + this.env.api.pass);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public filterToParams(filter: any): HttpParams {
    let params = new HttpParams();
    Object.keys(filter).forEach(key => (params = params.set(key, filter[key])));
    return params;
  }

  public getStandardHeader(): HttpHeaders {
    return this.standardHeader;
  }

  public getStandardPostHeader() {
    return this.standardPostHeader;
  }

  generateBearerHeader(token: string | undefined): HttpHeaders {
    this.bearerTokenHeader = new HttpHeaders({
      Authorization: 'Bearer ' + token,
      'USH-Channel': this.env.api.ushChannel,
      'Content-Type': 'application/json'
    });
    return this.bearerTokenHeader;
  }

  generateCustomBearerToken(token: string) {
    return new HttpHeaders({
      Authorization: 'Bearer ' + token
    });
  }
}
